import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IMagazaCiroAnalizi_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IMagazaCiroAnalizi_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetStoreSalesGrid: any[];
  GetStoreSalesGrid_dummy: any[];
  GetStoreSalesHeader: any[];
  GetStoreSalesHeader_dummy: any[];
  GetStoreSalesPerson: any[];
  GetStoreSalesPerson_dummy: any[];
  GetStoreSalesProcess: any[];
  GetStoreSalesProcess_dummy: any[];
  GetStoreWarehouse: any[];
  GetStoreWarehouse_dummy: any[];
  Boss_VStoreSalesCollection: any[];
  Boss_VStoreSalesCollection_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
}

export class MagazaCiroAnalizi_ScreenBase extends React.PureComponent<
  IMagazaCiroAnalizi_ScreenProps,
  any
> {
  magazaciroanalizi_999120_value_kuikaSelectBoxRef: React.RefObject<any>;
  magazaciroanalizi_525060_value_kuikaSelectBoxRef: React.RefObject<any>;
  magazaciroanalizi_38920_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "c60dfa67-aff8-48b8-8853-18fb4b56b4c6",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 976357, PropertyName: "label", Value: "Profil" },
        { Id: 446097, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 342102, PropertyName: "value", Value: "Mağaza Ciro Analizi" },
        { Id: 999120, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 554173, PropertyName: "value", Value: "Toplam Satış Miktarı" },
        { Id: 263376, PropertyName: "value", Value: "adet" },
        { Id: 429295, PropertyName: "value", Value: "Fatura" },
        { Id: 131904, PropertyName: "value", Value: "Plasiyer Bazında" },
        { Id: 859996, PropertyName: "value", Value: "Operasyonel Bazlı Satış" },
        { Id: 622157, PropertyName: "value", Value: "Mağaza/Depo Bazında" },
        { Id: 311977, PropertyName: "value", Value: "Toplam Satış Tutar" },
        { Id: 403097, PropertyName: "value", Value: "₺" },
        { Id: 224057, PropertyName: "value", Value: "Koleksiyon Bazlı" },
        { Id: 904302, PropertyName: "value", Value: "Mağazalar" },
        {
          Id: 525060,
          PropertyName: "placeholder",
          Value: "Ürün adet/Tutar bazlı arama...",
        },
        { Id: 636739, PropertyName: "placeholder", Value: "Mağaza Ara" },
        { Id: 178454, PropertyName: "label", Value: "Ara" },
        { Id: 530330, PropertyName: "label", Value: "Temizle" },
        {
          Id: 38920,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 97762, PropertyName: "title", Value: "Title" },
        { Id: 657610, PropertyName: "value", Value: "Mağaza Adı" },
        {
          Id: 733260,
          PropertyName: "value",
          Value: "[datafield:storedescription]",
        },
        { Id: 3684, PropertyName: "value", Value: "Adet" },
        { Id: 937904, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 736950, PropertyName: "value", Value: "Fatura Adet" },
        {
          Id: 788410,
          PropertyName: "value",
          Value: "[datafield:salesinvoicecount]",
        },
        { Id: 981268, PropertyName: "value", Value: "Tutar" },
        { Id: 2826, PropertyName: "value", Value: "[datafield:loc_netamount]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.magazaciroanalizi_999120_value_kuikaSelectBoxRef = React.createRef();
    this.magazaciroanalizi_525060_value_kuikaSelectBoxRef = React.createRef();
    this.magazaciroanalizi_636739_value_kuikaTextInputRef = React.createRef();
    this.magazaciroanalizi_38920_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetStoreSalesGrid: [],
      GetStoreSalesHeader: [],
      GetStoreSalesPerson: [],
      GetStoreSalesProcess: [],
      GetStoreWarehouse: [],
      Boss_VStoreSalesCollection: [],
      GetImage: [],
      SetValueOf: "",
      dataSource_999120: [
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son  6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      dataSource_525060: [
        { key: "0", text: "Adet Bazında" },
        { key: "1", text: "Tutar Bazında" },
      ],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("magazaciroanalizi", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.MagazaCiroAnaliziPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("magazaciroanalizi", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("magazaciroanalizi", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.MagazaCiroAnaliziPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      magazaciroanalizi_521690_value:
        this.state.GetImage?.at?.(0)?.photo ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  MagazaCiroAnaliziPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      paramByAmount_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      storeDescription_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(3, "number"),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(3, "number"),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(3, "number"),
      dateFilter_5: ReactSystemFunctions.convertToTypeByName(3, "number"),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MagazaCiroAnalizi/MagazaCiroAnaliziPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStoreSalesGrid = result?.data.getStoreSalesGrid;

    stateVars.GetStoreSalesHeader = result?.data.getStoreSalesHeader;
    formVars.magazaciroanalizi_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].qty1
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].qty1
        : null
    );
    formVars.magazaciroanalizi_119632_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].salesInvoiceCount
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].salesInvoiceCount
        : null
    );
    formVars.magazaciroanalizi_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].loc_NetAmount
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].loc_NetAmount
        : null
    );
    stateVars.GetStoreSalesPerson = result?.data.getStoreSalesPerson;

    stateVars.GetStoreSalesProcess = result?.data.getStoreSalesProcess;

    stateVars.GetStoreWarehouse = result?.data.getStoreWarehouse;

    stateVars.Boss_VStoreSalesCollection =
      result?.data.boss_VStoreSalesCollection;

    stateVars.GetImage = result?.data.getImage;
    formVars.magazaciroanalizi_521690_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MagazaCiroAnaliziPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.magazaciroanalizi_521690_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.magazaciroanalizi_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].qty1
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].qty1
        : null
    );

    formVars.magazaciroanalizi_119632_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].salesInvoiceCount
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].salesInvoiceCount
        : null
    );

    stateVars.dataSource_142941 =
      stateVars.GetStoreSalesPerson ?? this.state.GetStoreSalesPerson;

    stateVars.dataSource_768737 =
      stateVars.GetStoreSalesProcess ?? this.state.GetStoreSalesProcess;

    stateVars.dataSource_699596 =
      stateVars.GetStoreWarehouse ?? this.state.GetStoreWarehouse;
    formVars.magazaciroanalizi_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].loc_NetAmount
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_447949 =
      stateVars.Boss_VStoreSalesCollection ??
      this.state.Boss_VStoreSalesCollection;

    stateVars.dataSource_38920 =
      stateVars.GetStoreSalesGrid ?? this.state.GetStoreSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  MagazaCiroAnaliziComponent_891895_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MagazaCiroAnalizi",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "488099",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MagazaCiroAnaliziComponent_976357_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MagazaCiroAnalizi",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MagazaCiroAnaliziComponent_446097_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MagazaCiroAnaliziComponent_999120_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      paramByAmount_5: ReactSystemFunctions.convertToTypeByName(0, "number"),
      storeDescription_5: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MagazaCiroAnalizi/MagazaCiroAnaliziComponent_999120_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStoreSalesHeader = result?.data.getStoreSalesHeader;
    formVars.magazaciroanalizi_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].qty1
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].qty1
        : null
    );
    formVars.magazaciroanalizi_119632_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].salesInvoiceCount
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].salesInvoiceCount
        : null
    );
    formVars.magazaciroanalizi_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].loc_NetAmount
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].loc_NetAmount
        : null
    );
    stateVars.GetStoreSalesPerson = result?.data.getStoreSalesPerson;

    stateVars.GetStoreSalesProcess = result?.data.getStoreSalesProcess;

    stateVars.GetStoreWarehouse = result?.data.getStoreWarehouse;

    stateVars.Boss_VStoreSalesCollection =
      result?.data.boss_VStoreSalesCollection;

    stateVars.GetStoreSalesGrid = result?.data.getStoreSalesGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MagazaCiroAnaliziComponent_999120_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziComponent_999120_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.magazaciroanalizi_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].qty1
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].qty1
        : null
    );

    formVars.magazaciroanalizi_119632_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].salesInvoiceCount
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].salesInvoiceCount
        : null
    );

    stateVars.dataSource_142941 =
      stateVars.GetStoreSalesPerson ?? this.state.GetStoreSalesPerson;

    stateVars.dataSource_768737 =
      stateVars.GetStoreSalesProcess ?? this.state.GetStoreSalesProcess;

    stateVars.dataSource_699596 =
      stateVars.GetStoreWarehouse ?? this.state.GetStoreWarehouse;
    formVars.magazaciroanalizi_246069_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStoreSalesHeader !== undefined
        ? stateVars.GetStoreSalesHeader?.length > 0
          ? stateVars.GetStoreSalesHeader[0].loc_NetAmount
          : null
        : this.state.GetStoreSalesHeader?.length > 0
        ? this.state.GetStoreSalesHeader[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_447949 =
      stateVars.Boss_VStoreSalesCollection ??
      this.state.Boss_VStoreSalesCollection;

    stateVars.dataSource_38920 =
      stateVars.GetStoreSalesGrid ?? this.state.GetStoreSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MagazaCiroAnaliziComponent_525060_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      paramByAmount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_525060_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      storeDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_636739_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MagazaCiroAnalizi/MagazaCiroAnaliziComponent_525060_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStoreSalesGrid = result?.data.getStoreSalesGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MagazaCiroAnaliziComponent_525060_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziComponent_525060_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_38920 =
      stateVars.GetStoreSalesGrid ?? this.state.GetStoreSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MagazaCiroAnaliziComponent_178454_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_999120_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      paramByAmount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_525060_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      storeDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "magazaciroanalizi_636739_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MagazaCiroAnalizi/MagazaCiroAnaliziComponent_178454_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStoreSalesGrid = result?.data.getStoreSalesGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MagazaCiroAnaliziComponent_178454_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziComponent_178454_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_38920 =
      stateVars.GetStoreSalesGrid ?? this.state.GetStoreSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MagazaCiroAnaliziComponent_530330_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "magazaciroanalizi_636739_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "magazaciroanalizi_525060_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("0", "string"),
      null,
      "Key"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MagazaCiroAnaliziComponent_530330_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MagazaCiroAnaliziComponent_530330_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      paramByAmount_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      storeDescription_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MagazaCiroAnalizi/MagazaCiroAnaliziComponent_530330_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStoreSalesGrid = result?.data.getStoreSalesGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MagazaCiroAnaliziComponent_530330_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MagazaCiroAnaliziComponent_530330_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_38920 =
      stateVars.GetStoreSalesGrid ?? this.state.GetStoreSalesGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [488099] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.MagazaCiroAnaliziPageInit();
    }
  }
}
